import { Icon } from '@/components/common';
import Icons from '@/const/icons';

/** Chip that represents one selected answer in the filter header */
export const FilterChip: React.FC<{
	label: string;
	count: number;
	onRemove: () => void;
}> = ({ label, count, onRemove }) => (
	<span className="inline-flex items-center gap-2 bg-[#8039DF1A] border border-[#8039DF33] rounded-lg px-3 py-1.5 text-sm text-primary">
		{label}
		<span className="text-opacity-black font-normal">• {count} responses</span>
		<button
			type="button"
			onClick={onRemove}
			className="ml-0.5 hover:opacity-70 transition-opacity"
			aria-label={`Remove ${label} filter`}
		>
			<Icon src={Icons.close} width={18} height={18} className="text-primary" />
		</button>
	</span>
);
